import { Grid2 as Grid, Stack } from '@mui/material';
import { TextInput, EnumDropdown, useFormContext, WysiwygInput, DateInput, TogglerInput } from 'framework/form';
import React from 'react';
import RiskOwnerDropdown from '../RiskOwnerDropdown';
import { Button, EndDateIcon } from 'framework/ui/mui-builder';
import {
  RISK_TYPE_OPTIONS,
  PROJECT_PROBABILITY_OPTIONS,
  RISK_STATUS_OPTIONS,
  RISK_STATUS,
} from 'domain/shared/newProject';
import { useDateService } from 'framework/utils';
import { ALL_RISK_FIELDS_EDITABLE, RiskFieldPermissions } from '../useRiskPermissions';

interface RiskFormProps {
  isUpdateForm?: boolean;
  permissions?: RiskFieldPermissions;
  onCancelAction?: () => void;
}

const RiskForm = ({ isUpdateForm, permissions = ALL_RISK_FIELDS_EDITABLE, onCancelAction }: RiskFormProps) => {
  const { submitForm, isLoadingArtifact, isSubmitEnabled } = useFormContext();
  const { getToday } = useDateService();
  const { data } = useFormContext();
  const { canEditCustomerReportFlag, canEditRestrictedFields } = permissions;

  return (
    <Stack spacing={2} pt={isUpdateForm ? 2 : 0}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 12, md: isUpdateForm ? 3.5 : 4 }} sx={{ '& .floating-label-input': { mb: 0 } }}>
          <TextInput source="title" label="Risk" />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: isUpdateForm ? 1.7 : 2 }} sx={{ '& .floating-label-baseInput': { mb: 0 } }}>
          <EnumDropdown
            source="type"
            label="Risk type"
            options={RISK_TYPE_OPTIONS}
            disabled={!canEditRestrictedFields}
          />
        </Grid>
        {isUpdateForm && (
          <Grid size={{ xs: 12, sm: 6, md: isUpdateForm ? 1.7 : 2 }} sx={{ '& .floating-label-baseInput': { mb: 0 } }}>
            <EnumDropdown
              source="status"
              label="Status"
              options={RISK_STATUS_OPTIONS}
              disabled={!canEditRestrictedFields}
            />
          </Grid>
        )}
        <Grid size={{ xs: 12, sm: 6, md: isUpdateForm ? 1.7 : 2 }} sx={{ '& .floating-label-baseInput': { mb: 0 } }}>
          <EnumDropdown source="probability" label="Probability" options={PROJECT_PROBABILITY_OPTIONS} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: isUpdateForm ? 1.7 : 2 }} sx={{ '& .floating-label-baseInput': { mb: 0 } }}>
          <EnumDropdown source="severity" label="Severity" options={PROJECT_PROBABILITY_OPTIONS} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: isUpdateForm ? 1.7 : 2 }} sx={{ '& .floating-label-baseInput': { mb: 0 } }}>
          <RiskOwnerDropdown source="riskOwner" label="Owner" disabled={!canEditRestrictedFields} />
        </Grid>
        {isUpdateForm && data?.status === RISK_STATUS.INACTIVE && (
          <>
            <Grid size={{ xs: 12, sm: 6, md: 3.5 }} sx={{ '& .floating-label-input': { mb: 0 } }}>
              <DateInput
                label=""
                maxDate={getToday()}
                placeholder="Risk resolved date"
                dateIcon={
                  <EndDateIcon
                    sx={{
                      marginRight: '10px',
                      fontSize: '1.2rem',
                      position: 'absolute',
                      zIndex: 1,
                      left: '10px',
                      top: '10px',
                      opacity: '0.8',
                    }}
                  />
                }
                source="resolvedAt"
                disabled={!canEditRestrictedFields}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 8.5 }} sx={{ '& .floating-label-input': { mb: 0 } }}>
              <TextInput
                sx={{ backgroundColor: 'background.paper' }}
                source="resolveComment"
                label=""
                placeholder="Reason for resolving risk"
                disabled={!canEditRestrictedFields}
              />
            </Grid>
          </>
        )}
        <Grid size={12}>
          <WysiwygInput source="description" label="Description:" />
        </Grid>
      </Grid>
      <Grid size={12}>
        <WysiwygInput source="mitigationStrategy" label="Mitigation strategy:" />
      </Grid>
      <Grid size={12} sx={isUpdateForm ? { display: 'flex', pb: 2, justifyContent: 'flex-end' } : { pb: 3 }}>
        <TogglerInput
          checkedValue="Yes"
          uncheckedValue="No"
          source="isIncludedInCustomerReport"
          label="Include in the customer report"
          disabled={!canEditCustomerReportFlag}
        />
      </Grid>
      {!isUpdateForm && (
        <Grid container direction="row" justifyContent="flex-end" gap={1}>
          <Button variant="outlined" onClick={onCancelAction}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => (submitForm ? submitForm() : null)}
            disabled={!isSubmitEnabled || isLoadingArtifact}
          >
            Submit
          </Button>
        </Grid>
      )}
    </Stack>
  );
};
export default RiskForm;
